import delete_icon from "@assets/redesign/icons/trash.svg";
import Icon from "@components/global/new/Icon/Icon";
import PlanTime from "@components/global/new/PlanTime/PlanTime";
import styles from "./Option.module.scss";
import { IOptionProps } from "./Option.props";
import { useOptionControl } from "./useOptionControl";

export default function Option(props: IOptionProps) {

  const control = useOptionControl(props);

  return (
    <div className={`${styles.wrapper} ${props.rowNum % 2 === 0 ? styles.even : ""}`}>
      <PlanTime
        hh_12={false}
        id={`picker-${props.id}`}
        idx={props.id}
        value={props.option}
        error={props.isError}
        crossed={props.crossed}
        disabled={control.disabled || props.disabled}
      />
      {!(control.disabled || props.disabled) && (
        <Icon
          src={delete_icon}
          className={styles.icon}
          onClick={() => props.onDeletePeriod(props.id)}
          noHover
        />
      )}
    </div>
  );
}
